import {
  faList,
  faUserFriends,
  faPortrait,
} from '@fortawesome/pro-duotone-svg-icons'

const basePath = '/assets/products'
const appUrl = process.env.REACT_APP_APP_URL

export const tabsObject = [
  {
    icon: faList,
    id: 'myProcess',
    url: `${appUrl}/#/v2/home/processes`,
    image: '',
    translation: 'rankmiProducts.myProcess.newTitle',
  },
  {
    icon: faPortrait,
    id: 'summary',
    url: `${appUrl}/#/v2/home/profile/summary`,
    image: '',
    translation: 'rankmiProducts.summary.mainTitle',
  },
  {
    icon: '',
    id: 'actionPlans',
    url: `${appUrl}/#/v2/home/profile/actionPlans`,
    image: `${basePath}/planes-de-accion.svg`,
    translation: 'rankmiProducts.actionPlans.title',
  },
  {
    icon: '',
    id: 'performance',
    url: `${appUrl}/#/v2/home/profile/performance`,
    image: `${basePath}/desempeno.svg`,
    translation: 'rankmiProducts.performance.title',
  },
  {
    icon: '',
    id: 'performanceResults',
    url: `${appUrl}/#/v2/home/performance-results`,
    image: `${basePath}/desempeno.svg`,
    translation: 'rankmiProducts.performanceResults.title',
  },
  {
    icon: '',
    id: 'appsCenter',
    url: `${appUrl}/#/v2/ho{t(tab.translation)}me/appsCenter`,
    image: `${basePath}/genius.svg`,
    translation: 'rankmiProducts.appsCenter.title',
  },
  {
    icon: '',
    id: 'organigram',
    url: `${appUrl}/#/v2/home/organigram`,
    image: `${basePath}/organigrama.svg`,
    translation: 'rankmiProducts.organigram.title',
  },
  {
    icon: '',
    id: 'lms',
    url: '/',
    image: `${basePath}/lms.svg`,
    translation: 'rankmiProducts.lms.title',
  },
  {
    icon: '',
    id: 'newContinuousFeedback',
    url: `${appUrl}/#/v2/home/continuous-feedback`,
    image: `${basePath}/feedback.svg`,
    translation: 'rankmiProducts.newContinuousFeedback.title',
  },
  {
    icon: '',
    id: 'news',
    url: `${appUrl}/#/v2/home/news`,
    image: `${basePath}/news.svg`,
    translation: 'rankmiProducts.news.title',
  },
  {
    icon: '',
    id: 'reports',
    url: `${appUrl}/#/v2/home/reports`,
    image: `${basePath}/report.svg`,
    translation: 'rankmiProducts.reports.title',
  },
  {
    icon: '',
    id: 'payroll',
    url: process.env.REACT_APP_PAYROLL_APP_URL,
    image: `${basePath}/payroll.svg`,
    translation: 'rankmiProducts.payroll.title',
  },
  {
    icon: '',
    id: 'ats',
    url: process.env.REACT_APP_ATS_APP_URL,
    image: `${basePath}/ats.svg`,
    translation: 'rankmiProducts.ats.title',
  },
  {
    icon: '',
    id: 'employee',
    url: `${appUrl}/#/v2/home/help-center`,
    image: `${basePath}/employee.svg`,
    translation: 'rankmiProducts.employee.title',
  },
  {
    icon: '',
    id: 'openSurvey',
    url: `${appUrl}/#/v2/home/surveys-forms`,
    image: `${basePath}/encuestas-rapidas.svg`,
    translation: 'rankmiProducts.openSurvey.title',
  },
  {
    icon: '',
    id: 'documents',
    url: `${appUrl}/#/v2/home/documents`,
    image: `${basePath}/documentos.svg`,
    translation: 'rankmiProducts.documents.title',
  },
  {
    icon: faPortrait,
    id: 'profile',
    url: `${appUrl}/#/v2/home/profiles`,
    image: '',
    translation: 'rankmiProducts.summary.mainTitle',
  },
  {
    icon: '',
    id: 'checkin',
    url: `${appUrl}/#/v2/home/checkin`,
    image: `${basePath}/checkin.svg`,
    translation: 'rankmiProducts.checkin.title',
  },
  {
    icon: '',
    id: 'workflows',
    url: `${appUrl}/#/v2/home/workflows`,
    image: `${basePath}/workflows.svg`,
    translation: 'rankmiProducts.workflows.title',
  },
  {
    icon: faUserFriends,
    id: 'directTeam',
    url: `${appUrl}/#/v2/home/profile/team`,
    image: '',
    translation: 'rankmiProducts.directTeam.title',
  },
  {
    icon: '',
    id: 'generalDashboard',
    url: `${appUrl}/#/v2/home/dashboards`,
    image: `${basePath}/dashboards.svg`,
    translation: 'rankmiProducts.generalDashboard.title',
  },
  {
    icon: '',
    id: 'benefits',
    url: `${appUrl}/#/v2/home/benefits`,
    image: `${basePath}/benefits.svg`,
    translation: 'rankmiProducts.benefits.title',
  },
  {
    icon: '',
    id: 'acknowledgments',
    url: `${appUrl}/#/v2/home/acknowledgments`,
    image: `${basePath}/acknowledgments.svg`,
    translation: 'rankmiProducts.acknowledgments.title',
  },
  {
    icon: '',
    id: 'meetings',
    url: `${appUrl}/#/v2/home/meetings`,
    image: `${basePath}/meetings.svg`,
    translation: 'rankmiProducts.meetings.title',
  },
  {
    icon: '',
    id: 'tempo',
    url: `${appUrl}/#/v2/home/tempo/`,
    image: `${basePath}/tempo.svg`,
    translation: 'rankmiProducts.tempo.title',
  },
]
